<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit='fetchReport')
  .full-height.loading.loading-lg(v-if='loading')
  div(v-else-if="report.length")
    .card.my-2.no-print
      .card-header
        .h5 Média geral mensal
      .card-body.chart-body
        line-chart(:data="chartData")
    .card.my-2
      .card-header
        .h5 Tabela da média geral mensal
      .card-body
        table.table.table-striped
          thead
            tr
              th {{ 'pontuacao_geral.referencia' | tModel }}
              th {{ 'pontuacao_geral.media_total' | tModel }}
              th {{ 'pontuacao_geral.media_individual_liquido' | tModel }}
              th {{ 'pontuacao_geral.media_extraordinario' | tModel }}
              th {{ 'pontuacao_geral.media_perdidos' | tModel }}
          tbody
            tr(v-for="geral in report")
              td {{ geral.referencia }}
              td {{ geral.media_total }}
              td {{ geral.media_individual_liquido }}
              td {{ geral.media_extraordinario }}
              td {{ geral.media_perdidos }}
  .card.mt-2(v-else)
    .card-body
      .empty
        .empty-icon
          i.fa.fa-search.fa-4x
        p.empty-title.h5 Nada encontrado
        p.empty-subtitle Não foram encontrados registros de produtividade neste período  
</template>

<script>
import FormFilter from './components/Filter.vue'
import produtividade from '@/api/indicadores/produtividade'
import date from '@/filters/date'
import toastErrors from '@/lib/errors/toastErrors'

function mountChartData(key, report) {
  return report.reduce((acc, geral) => {
    acc[date(`${geral.referencia}-02`, 'MM/YYYY')] = geral[key]
    return acc
  }, {})
}

export default {
  data() {
    return {
      loading: false,
      report: [],
    }
  },
  computed: {
    chartData() {
      return [
        {
          name: 'Média total',
          data: mountChartData('media_total', this.report),
          color: 'green',
        },
        {
          name: 'Média individual líquida',
          data: mountChartData('media_individual_liquido', this.report),
          color: 'blue',
        },
        {
          name: 'Média extraordinária',
          data: mountChartData('media_extraordinaria', this.report),
          color: 'indigo',
        },
        {
          name: 'Média perdidos',
          data: mountChartData('media_perdidos', this.report),
          color: 'red',
        },
      ]
    },
  },
  components: { FormFilter },
  methods: {
    async fetchReport(q) {
      try {
        this.loading = true
        this.report = await produtividade.gerais({ q })
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
